import Component from '../abstracts/Component';

export default class O2OComponent extends Component {

  get COMPONENTNAME() {
    return 'O2OComponent';
  }

  get SELECTORS() {
    return {
      carousel: '[data-carousel]',
      item: '[data-item]',
      track: '.slick-list',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.carousel = this.$component.querySelector(this.SELECTORS.carousel);
    this.items = this.$component.querySelectorAll(this.SELECTORS.item);
    var showCarousel = false;
  }

  setOptions() {
    const customPaging = function(slider, i) {
      return $('<i class="icon-slider-bullet"></i><i class="icon-slider-bullet-active"></i>');
    };
    let responsiveArray = [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ];
    let options = {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: true,
      swipe: true,
      draggable: true,
      responsive: responsiveArray,
      prevArrow: '<button type="button" class="w__slick-prev icon-slick-prev" aria-label="previous slide" data-prev-arrow><i class="icon-slick-prev"></i></button>',
      nextArrow: '<button type="button" class="w__slick-next icon-slick-next" aria-label="next slide" data-next-arrow><i class="icon-slick-next"></i></button>',
      customPaging: customPaging,
    };
    if (this.carousel.getAttribute('data-carousel') != 'false') {
      this.initCarousel(options);
      this.setSlideHeight();
    }
  }

  initCarousel(options) {
    $(this.carousel).on('init', () => {
      //this.animateArrows();
    });
    if(this.isTablet()) {
      if(this.items.length > 2){
        $(this.carousel).slick(options);
        this.showCarousel = true;
      }
    }
    if(this.isMobile()) {
      if(this.items.length > 1) {
        $(this.carousel).slick(options);
        this.showCarousel = true;
      }
    }
    if(!this.isTablet() && !this.isMobile() && this.items.length > 2) {
      $(this.carousel).slick(options);
      this.showCarousel = true;
    }
  }

  animateArrows() {
    let prevArrow = this.carousel.querySelector(this.SELECTORS.prevArrow);
    if (prevArrow) {
      prevArrow.addEventListener('mousedown', () => {
        prevArrow.classList.remove('transition');
      });
      prevArrow.addEventListener('click', () => {
        prevArrow.classList.add('transition');
      });
    }
    let nextArrow = this.carousel.querySelector(this.SELECTORS.nextArrow);
    if (nextArrow) {
      nextArrow.addEventListener('mousedown', () => {
        nextArrow.classList.remove('transition');
      });
      nextArrow.addEventListener('click', () => {
        nextArrow.classList.add('transition');
      });
    }
  }

  setSlideHeight() {
    let track = this.$component.querySelector(this.SELECTORS.track);
    if (!this.showCarousel && track && this.items.length > 1) {
      let trackHeight = track.offsetHeight;
      let items = this.$component.querySelectorAll('.slick-slide [data-item]');
      items.forEach(item => {
        item.style.display = 'flex';
        item.style.height = `${trackHeight}px`;
      });
    }
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(module => {
        this.setOptions();
      },
      error => {
        console.error('failed to load slick', error.stack);
      }
    );
  }

  isMobile() {
    let mq = window.matchMedia('(max-width: 767px)');
    let isMobile = mq.matches;
    return isMobile;
  }

  isTablet() {
    let mq = window.matchMedia('(max-width: 991px)');
    let isTablet = mq.matches;
    return isTablet;
  }

  render() {
    this.log('Rendering...');
    if (this.carousel && this.items.length > 1) {
      this.importSlick();
    }
  }
}
